var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcLogicWebAccount = function SvgIcLogicWebAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 78 78"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M39.78 41.08h-2.34c-7.54 0-13.78-6.24-13.52-14.04 0-7.54 6.24-13.52 13.52-13.52h2.34c7.54 0 13.78 5.98 14.04 13.52 0 7.54-5.98 13.78-13.52 14.04zM37.7 17.94c-5.2 0-9.62 4.42-9.62 9.62s4.42 9.62 9.62 9.62h2.34c5.2 0 9.62-4.42 9.62-9.62s-4.42-9.62-9.62-9.62zM61.36 70.2H17.42c-1.04 0-2.08-1.04-2.08-2.08v-8.84c0-8.58 6.76-15.34 15.34-15.34H48.1c8.58 0 15.34 6.76 15.34 15.34v8.84c0 1.04-1.04 2.08-2.08 2.08M19.5 66.04h39.78v-6.76c0-6.24-4.94-11.18-11.18-11.18H30.68c-6.24 0-11.18 4.94-11.18 11.18z",
    style: {
      fill: "currentColor"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h78v78H0z"
  })));
};
export default SvgIcLogicWebAccount;